import Translate from "@service/Translate";
import  { FC } from "react";
import ContentLoader from "react-content-loader";

interface ISkeletonCurrentTripsProps {
}

const SkeletonCurrentTrips: FC<ISkeletonCurrentTripsProps> = () => {
    const { tr } = Translate;
    let currentTrips;

    const item = <ContentLoader
        width="100%"
        height="100%"
        title={tr("msg_info_loading")}
        speed={1}
        backgroundColor="#f2f2f2"
        foregroundColor="#ecebeb"
        rtl
    >
        {/* Only SVG shapes */}
        <rect x="0" y="0" rx="10" ry="10" width="100%" height="26" />
    </ContentLoader>
    for (let i = 0, li = 2; i < li; i++) {
        currentTrips = <>{currentTrips}
            <div className="row flex current-trips-item">
                <div className="col-1-4 col-sm-1-1 current-trips-item-cell">
                    {item}
                </div>
                <div className="col-1-4 col-sm-1-1 current-trips-item-cell">
                    {item}
                </div>
                <div className="col-1-4 col-sm-1-1 current-trips-item-cell">
                    {item}
                </div>
                <div className="col-1-4 col-sm-1-1 current-trips-item-cell">
                    {item}
                </div>
            </div>
        </>
    }
    return (
        <div className="skeleton-current-trips">
            {currentTrips}
        </div>
    )
}

export default SkeletonCurrentTrips;